/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidSubmissionsControllerListQueryResponse, BidSubmissionsControllerListQueryParams, BidSubmissionsControllerList401, BidSubmissionsControllerList403 } from "../../models/bidsController/BidSubmissionsControllerList";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { bidSubmissionsControllerList } from "../../clients/bidsService/bidSubmissionsControllerList";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const bidSubmissionsControllerListQueryKey = (params: BidSubmissionsControllerListQueryParams) => [{
  url: '/api/v1/bid-submissions'
}, ...(params ? [params] : [])] as const;
export type BidSubmissionsControllerListQueryKey = ReturnType<typeof bidSubmissionsControllerListQueryKey>;
export function bidSubmissionsControllerListQueryOptions(params: BidSubmissionsControllerListQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = bidSubmissionsControllerListQueryKey(params);
  return queryOptions<BidSubmissionsControllerListQueryResponse, ResponseErrorConfig<BidSubmissionsControllerList401 | BidSubmissionsControllerList403>, BidSubmissionsControllerListQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return bidSubmissionsControllerList(params, config);
    }
  });
}

/**
 * @summary List a trade's bids and replies, newest first
 * {@link /api/v1/bid-submissions}
 */
export function useBidSubmissionsControllerList<TData = BidSubmissionsControllerListQueryResponse, TQueryData = BidSubmissionsControllerListQueryResponse, TQueryKey extends QueryKey = BidSubmissionsControllerListQueryKey>(params: BidSubmissionsControllerListQueryParams, options: {
  query?: Partial<QueryObserverOptions<BidSubmissionsControllerListQueryResponse, ResponseErrorConfig<BidSubmissionsControllerList401 | BidSubmissionsControllerList403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? bidSubmissionsControllerListQueryKey(params);
  const query = useQuery({
    ...bidSubmissionsControllerListQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BidSubmissionsControllerList401 | BidSubmissionsControllerList403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}